import {useQuery} from "@tanstack/react-query";
import {getModelBySearchString} from "../../api/catalog";
import CatalogList from "./CatalogList";
import {useContext, useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";

export default function CatalogListBySearchString() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext)
    const [searchParams] = useSearchParams()
    
    const searchQuery = searchParams.get('q') || state.searchHistory[0] || ''

    const {data: modelColorItemsData} = useQuery({
        queryKey: ['catalog', 'search', searchQuery || null],
        queryFn: () => getModelBySearchString(searchQuery || undefined),
        enabled: Boolean(searchQuery),
        retry: false
    })

    const {
        model_color_items: modelColorItems,
        meta,
        category,
        breadcrumbs,
        banners,
        tags,
        super_categories,
        categories,
        properties
    } = modelColorItemsData || {
        model_color_items: [],
        super_categories: [],
        categories: [],
        meta: undefined,
        properties: []
    }

    useEffect(() => {
        dispatch({type: ReducerActionType.SET_PARAM, paramName: 'meta', payload: modelColorItemsData?.meta})
    }, [modelColorItemsData?.meta]);


    return (<CatalogList modelColorItems={modelColorItems}  category={category} repository={null} breadcrumbs={breadcrumbs}
                         banners={banners} superCategories={super_categories} categories={categories} tags={tags} properties={properties} filterTags={[]}></CatalogList>)
}